import * as css from './videoForm.css';
import {useTranslation} from 'react-i18next';
import Input from '../../../component/input/Input';
import InputList from '../../../component/input/inputList/InputList';
import {useField} from 'formik';
import MemberRoleBtn from '../../../pages/team/memberRoleBtn/MemberRoleBtn';
import TooltipAbsolute from '../../../component/tooltip/tooltipAbsolute/TooltipAbsolute';
import {roles} from '../../../pages/team/Team';
import {menuEvent} from '../../menu';
import {menuAccount} from '../../menuAccount';
import Camera from '../../../assets/icons/camera';
import VideoFormPopBottom from './vidoeFormPopBottom';
import removeDuplicateObjects from '../../../functions/removeDuplicateObjects';
import { getPageTranslation } from '../supportVideos/SupportVideosHeader';
import TextEditorFormik from '../../../component/textEditor/TextEditorFormik';
import { star } from '../../../assets/symbols/symbols/Symbols.css';
import TextareaInput from '../../../component/input/textareaInput/TextareaInput';

export const ALL_TEAM_KEY = 'allTeam';
    
const getTitle = ({packagePage, page, subPage, routeType})=>`${routeType||''}${routeType?'_':''}${packagePage || page || 'unknown_page'}${subPage?'_':''}${subPage||''}`;

function VideoForm({videoId, removeVideo, formRef}) {
    const {t} = useTranslation('layout');
    const inputProps=(name)=>({name,text:t(name),description:t(`${name}Desc`),className:name});
    const [DRoleField,DRoleMeta, DRoleHelper]=useField('permission');
    const [pageField,pageMeta, pageHelper]=useField('page');
    const [, summaryMeta] = useField('summary');
    const rolesList = [ALL_TEAM_KEY, ...roles].map(role=>({
        key: role,
        text: t(role),
    }));
    
    const onRoleChanged = (name, itemKey) => {
        if(itemKey === ALL_TEAM_KEY)
            DRoleHelper.setValue([ALL_TEAM_KEY]);
    };
    
    const removePage = (itemKey) => {
        pageHelper.setValue(pageField.value.filter(page=>page!==itemKey));
    };
    const handleMemberRoleChange = (role) => {
        DRoleHelper.setValue(DRoleField.value.filter(r => role !== r));
    };
    const classes = `${DRoleMeta.touched && (DRoleMeta.error ? ' invalid' : ' valid')}`;
    const SClasses = `${pageMeta.touched && (pageMeta.error ? ' invalid' : ' valid')}`;
    
    const paths = [
        {path: '/login/forgetPassword', routeType:''},
        {path: '/login', routeType:''},
        {path: '/signup', routeType:''},
        ...Object.values(menuEvent).map(menuItem=>({path:menuItem.path, routeType: 'event'})),
        ...Object.values(menuAccount).map(menuItem=>({path:menuItem.path, routeType: 'package'})),
        {path: '/notFound', routeType: '404'}];

    const pagesList = removeDuplicateObjects(paths, ['path']).map(path =>{
        if(path?.path){
            const splitPath = path.path.split('/');
            const title = getTitle({packagePage:'',page:splitPath[1],subPage: splitPath[2], routeType:path.routeType});
            return {key: title, text: getPageTranslation(t, title), type: 'checkbox', selected: pageField.value?.includes(title)};
        }
    }).filter(Boolean);


    return (<>
        <css.container>
            <Input events={undefined} icon={<Camera />} forwardRef={undefined}{...inputProps('title')}/> 
            <Input events={undefined} icon={'copy'} forwardRef={undefined}{...inputProps('videoLink')}/>
            <css.textEditorWrapper charText={t('chars')} >
                <css.textEditorLabel>
                    {t('summary')}
                    {summaryMeta.touched && summaryMeta.error && (<TooltipAbsolute show={true} text={summaryMeta.error} dataTitleIcon={undefined} icon={star} /> )}
                </css.textEditorLabel>
                <TextareaInput 
                    {...inputProps('summary')}
                    icon={undefined}
                    text=''
                    description=''
                    events={undefined}
                    height='150px'
                    limit={150}
                />
            </css.textEditorWrapper>
            <css.descriptionWrapper>
                <css.textEditorLabel>{t('description')}</css.textEditorLabel>
                <TextEditorFormik 
                    name="description"
                    showToolbar={true}
                    expanded={true}
                    minHeight={300}
                    disableVariables={true}
                />
            </css.descriptionWrapper>
            <css.roleSelectInput className={classes}>
                <InputList onChange={onRoleChanged} multiSelect={true} name='permission' list={rolesList} text={t('userPermission')} isSelectable={true} icon={undefined} className={undefined} valid={undefined} onFocus={undefined} > </InputList>
                <css.rolesContainer>{DRoleField.value?.map(role=><MemberRoleBtn onclick={handleMemberRoleChange} key={role} member={{role}} />)}</css.rolesContainer>
                {DRoleMeta.touched && DRoleMeta.error && (<TooltipAbsolute show={true} text={DRoleMeta.error} dataTitleIcon={undefined} icon={undefined} /> )}          
            </css.roleSelectInput> 
            <css.roleSelectInput className={SClasses}>
                <InputList 
                    multiSelect={true} name='page' list={pagesList} text={t('systemArea')} isSelectable={true} icon={undefined} className={undefined} valid={undefined} onFocus={undefined} > </InputList>
                <css.selectedPageContainer>{pageField.value?.map(page=> <css.selectedPageType key={page} onClick={()=>removePage(page)}>{getPageTranslation(t, page)}</css.selectedPageType>)}</css.selectedPageContainer>
                {pageMeta.touched && pageMeta.error && (<TooltipAbsolute show={true} text={pageMeta.error} dataTitleIcon={undefined} icon={undefined} /> )}          
            </css.roleSelectInput> 
        </css.container>
        <VideoFormPopBottom hasVideoId={!!videoId} remove={removeVideo} formRef={formRef} />
    </>);
   
}

export default VideoForm;